<msf-summary-wrapper
  title="{{ 'Weather' | translate }}"
  [items]="MENU_ITEMS | menuChildren:MenuItemType.Weather" leftSize="7"
  rightSize="5"
>
  <div right #right>
    <div class="summary-card mt-4">
      <h2 class="summary-title">{{ 'Сводная информация' | translate }}</h2>

      <app-problem-areas
        [allRegionsLevel2]="allRegionsLevel2"
        [totalRegions]="totalRegions"
        [totalArea]="totalArea">
      </app-problem-areas>

      <!-- Natural Disasters Section -->
      <app-disasters-section
        [totalArea]="totalArea"
        (disasterClick)="openDisasterModal($event)">
      </app-disasters-section>

      <!-- Data Sources Section -->
      <app-data-sources [sources]="sources"></app-data-sources>
    </div>
  </div>
</msf-summary-wrapper>

